import { render, staticRenderFns } from "./AdminRegistravimasAutomatu.vue?vue&type=template&id=2c1b5d79&scoped=true&"
import script from "./AdminRegistravimasAutomatu.vue?vue&type=script&lang=js&"
export * from "./AdminRegistravimasAutomatu.vue?vue&type=script&lang=js&"
import style0 from "./AdminRegistravimasAutomatu.vue?vue&type=style&index=0&id=2c1b5d79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1b5d79",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCol,VContainer,VDataTable,VRow,VTab,VTabs,VTextField,VToolbar})
